var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.06398cm",
    height: "4.0639cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1067.2 1067.18",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "git.svg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F05133",
    fillRule: "nonzero",
    d: "M1047.07 486.05l-465.94 -465.92c-26.83,-26.84 -70.35,-26.84 -97.2,0l-96.74 96.77 122.73 122.73c28.52,-9.64 61.23,-3.17 83.96,19.57 22.87,22.88 29.28,55.86 19.4,84.49l118.3 118.29c28.63,-9.87 61.63,-3.48 84.49,19.41 31.94,31.94 31.94,83.69 0,115.65 -31.96,31.95 -83.71,31.95 -115.69,0 -24.02,-24.04 -29.96,-59.34 -17.78,-88.94l-110.33 -110.32 0 290.32c7.78,3.85 15.13,8.99 21.61,15.47 31.94,31.94 31.94,83.69 0,115.66 -31.94,31.93 -83.73,31.93 -115.64,0 -31.94,-31.98 -31.94,-83.74 0,-115.66 7.9,-7.89 17.03,-13.85 26.79,-17.85l0 -293.02c-9.76,-3.99 -18.87,-9.91 -26.79,-17.85 -24.19,-24.18 -30.01,-59.7 -17.61,-89.4l-120.99 -121 -319.5 319.47c-26.84,26.86 -26.84,70.38 0,97.22l465.96 465.93c26.83,26.84 70.33,26.84 97.2,0l463.77 -463.77c26.84,-26.84 26.84,-70.38 0,-97.22z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.86bd384f.svg";
export { ForwardRef as ReactComponent };